export const appConfig = {
  baseBackendUrl: process.env.REACT_APP_DAMS_BACKEND_URL ?? "",
  authAccessToken: process.env.REACT_APP_LOGIN_AUTH_TOKEN ?? "__dms_auth_token",
  ghostUrl: process.env.REACT_APP_SUPPORT_URL ?? "#support",
} as const;

export type AppConfig = (typeof appConfig)[keyof typeof appConfig];
